import { render, staticRenderFns } from "./notHavePrize.vue?vue&type=template&id=34a0f726&scoped=true"
import script from "./notHavePrize.vue?vue&type=script&lang=js"
export * from "./notHavePrize.vue?vue&type=script&lang=js"
import style0 from "./notHavePrize.vue?vue&type=style&index=0&id=34a0f726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0f726",
  null
  
)

export default component.exports